import { IClientLpStoreSegment } from './clientLp.interface';

export const clientLpStoreSelector = (state: IClientLpStoreSegment) => state.clientLp;
